import React, { createContext, useContext, useState } from 'react';

type VarValues = {
  values: Record<string, string>;
  setVar: (name: string, value: string) => void;
};

const VarValuesContext = createContext<VarValues>({ values: {}, setVar: () => {} });

// Holds variable values (e.g. `slug`) keyed by name at the Explorer root, so a
// value entered for one starter carries over to others with the same variable.
export function VarValuesProvider({ children }: { children: React.ReactNode }) {
  const [values, setValues] = useState<Record<string, string>>({});
  const setVar = (name: string, value: string) =>
    setValues((prev) => ({ ...prev, [name]: value }));
  return (
    <VarValuesContext.Provider value={{ values, setVar }}>
      {children}
    </VarValuesContext.Provider>
  );
}

export function useVarValues(): VarValues {
  return useContext(VarValuesContext);
}
